import React, { useState } from 'react'
import useStyles from '../editDetailsStyles'
import { TextInput } from 'app/components/FormsyHelperComponent'
import CloseIcon from '@material-ui/icons/Close'
import ConfirmDeleteCustomFieldPopup from '../confirmDeleteCustomFieldPopup'

const CustomFieldForm = ({
  customField,
  updateCustomFieldsContentData,
  parentMethod,
  index,
  deleteCustomLabel,
  isLocal,
  validations,
  validationErrors,
  variant = 'standard',
  confirmDelete = true,
}) => {
  const [openDeleteCustomField, setOpenDeleteCustomField] = useState(null)
  const styleClass = useStyles()
  return (
    <div key={index} className={styleClass.customLabelWrapper}>
      <TextInput
        containerClassName="MuiFormControl-fullWidth"
        labelId={customField.label}
        placeholderId={customField.label}
        variant="outlined"
        fullWidth
        name={customField.label}
        onChange={(event) => {
          updateCustomFieldsContentData({
            value: event.target.value,
            method: parentMethod,
            id: customField.id || customField.localId,
            isLocal: isLocal,
            labelType: customField && customField.labelType,
          })
        }}
        value={customField.content}
        validations={
          customField.customAttributes.labelType !== 'Other' && validations
        }
        validationErrors={
          customField.customAttributes.labelType !== 'Other' && validationErrors
        }
      />
      <CloseIcon
        onClick={() =>
          confirmDelete
            ? setOpenDeleteCustomField(customField.id || customField.localId)
            : deleteCustomLabel(customField, parentMethod)
        }
        fontSize="small"
        className={styleClass.customLabelCloseIcon}
      />
      <ConfirmDeleteCustomFieldPopup
        deleteCustomLabel={() => deleteCustomLabel(customField, parentMethod)}
        openDeleteCustomField={
          openDeleteCustomField === (customField.id || customField.localId)
        }
        setOpenDeleteCustomField={setOpenDeleteCustomField}
      />
    </div>
  )
}

export default CustomFieldForm
